<section class="swiper-section box-swiper" [attr.aria-label]="(title || 'Cuisines') + ' section'">
  <div class="swiper-section-header">
    <div class="swiper-section-header-content">
      <h3 class="swiper-section-title">{{ title }}</h3>
    </div>
    <div #navButtonContainer class="swiper-section-navigation">
      <button #prevBtn mat-icon-button class="box-swiper-button-prev" aria-label="Previous cuisines">
        <mat-icon fontSet="material-icons-round">chevron_left</mat-icon>
      </button>
      <button #nextBtn mat-icon-button class="box-swiper-button-next" aria-label="Next cuisines">
        <mat-icon fontSet="material-icons-round">chevron_right</mat-icon>
      </button>
    </div>
  </div>
  <div [swiper]="swiperOptions" *ngIf="mainViewTiles?.length > 0">
    <div class="swiper-wrapper" role="navigation" [attr.aria-label]="(title || 'Cuisines') + ' tiles'">
      <div
        class="swiper-slide"
        *ngFor="let tile of mainViewTiles"
        (click)="onCuisineClick(tile.item)"
        (keydown.enter)="onCuisineClick(tile.item)"
        role="link"
        tabindex="0"
      >
        <div
          [reactComponent]="CollapsibleTileComponent$"
          visibilityObserver
          [triggerOnce]="true"
          [intersectionThresholds]="DEFAULT_INTERSECTION_THRESHOLDS"
          (enteredViewport)="onCuisineEnteredViewport(tile.item)"
          [props]="{ tile, size: 'large', collapsed: false }"
        ></div>
      </div>
      <div class="swiper-slide">
        <button
          box-button
          theme="secondary"
          class="home-cuisine-action ods-typography-button-l"
          (click)="onAction()"
          [attr.aria-label]="'see_them_all' | translate"
          role="link"
          tabindex="0"
        >
          {{ 'see_them_all' | translate }}
        </button>
      </div>
    </div>
  </div>
</section>
